// src/features/dashboard/components/dashboard-panel.tsx
import React from 'react';

interface DashboardPanelProps {
  title: string;
  children: React.ReactNode;
  className?: string;
  action?: React.ReactNode;
}

export const DashboardPanel: React.FC<DashboardPanelProps> = ({ title, children, className, action }) => {
  return (
    <div className={`bg-white rounded-xl shadow-sm border p-6 ${className ?? ''}`}>
      <div className="flex items-center justify-between mb-4">
        <h2 className="text-lg font-semibold text-gray-900">{title}</h2>
        {action && <div>{action}</div>}
      </div>
      <div className="h-full">{children}</div>
    </div>
  );
};
